import React, { FC, memo } from 'react'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import { authSelectors } from '@ucheba/store/auth'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { EActivityTypes } from '@ucheba/utils/types/userActivityTypes'
import { LimitedList } from '@ucheba/ui/components/LimitedList/desktop/LimitedList'
import { EActivityInfoPart, IInstitutionExamsProps } from '../types'
import { useUserActivity } from '../../../../utils/hooks/useUserActivity'
import { ExamsList } from '../../ExamsList/desktop'
import { getLinkProps } from '../bll'

const InstitutionExams: FC<IInstitutionExamsProps> = ({ data }) => {
  const isAuth = useSelector(authSelectors.isAuth)
  const router = useRouter()
  const {
    query: { id: institutionId },
  } = router

  const { setUserActivity } = useUserActivity()

  const handleShowAllClick = async (): Promise<void> => {
    await setUserActivity({
      activityType: EActivityTypes.infoPartViewed,
      institutionId: Array.isArray(institutionId)
        ? Number(institutionId[0])
        : Number(institutionId),
      data: { infoPart: EActivityInfoPart.egeVariants },
    })
  }

  return (
    <>
      <Heading h2='С какими ЕГЭ можно поступать' spacing='xlarge' />

      <LimitedList
        items={data}
        limit={3}
        onShowAll={() => {
          handleShowAllClick()
        }}
        buttonText='Показать все наборы ЕГЭ'
        id='egeVariants'
        isAuth={isAuth}
        showAllButtonLinkIsLink={false}
      >
        {({ limitedItems }) => (
          <ExamsList
            id={institutionId}
            items={limitedItems}
            getLinkProps={getLinkProps}
          />
        )}
      </LimitedList>
    </>
  )
}

export default memo(InstitutionExams)
